// extracted by mini-css-extract-plugin
module.exports = {"main-wrapper":"BlogHeader_main-wrapper__rTAxO","closed":"BlogHeader_closed__ojgBW","wrapper":"BlogHeader_wrapper__1_p_a"};